export class LineItem {
    sku: string
    total: number
    quantity: number
    price_per_unit: number
    title: string
    statementId?: number

    constructor(d: any) {
        this.sku = d?.sku
        this.total = d?.total
        this.quantity = d?.quantity
        this.price_per_unit = d?.price_per_unit ?? d?.unitPrice
        this.title = d?.title ?? d?.line_item_sale_item_static_description?.title ?? d?.sku_title
        this.statementId = d?.statementId
    }

    isETaxLineItem(): boolean {
        return this.sku === "ETAX_0001"
    }

    getTotal(): number {
        return this.total ?? this.price_per_unit * this.quantity
    }

    static buildLineItem(li: any): LineItem {
        return new LineItem(li)
    }
}
